import React from 'react';
import { Button } from '.';
import { useLogout } from '../service';

interface LogoutModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const LogoutModel: React.FC<LogoutModalProps> = ({
    isOpen,
    onClose
}) => {
    const { mutate: logout } = useLogout()

    const handleLogout = () => {
        logout(undefined, {
            onSuccess: () => {
                onClose();
            }
        });
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50" onClick={onClose}>
            <div className=" bg-secondary rounded-xl w-4/5 md:w-1/2 lg:w-1/5 z-[100]" onClick={(e) => e.stopPropagation()}>
                <div className="flex flex-col gap-4 lg:mx-10 my-8">
                    <p className="text-md text-textColor font-outfit text-center">
                        Are you sure you want to log out?
                    </p>
                    <div className='flex gap-3 justify-center'>
                        <Button name='Confirm' type='first' htmlType='button' onClick={handleLogout} />
                        <Button name='Cancel' type='second' htmlType='button' onClick={onClose} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LogoutModel;